import React from 'react'

import { FlexDiv } from 'components/generic/HomePageComponents'
import PrimaryButton from 'components/generic/PrimaryButton'
import GenericLazyLoadImage from 'components/generic/GenericLazyLoadImage'
import {
  Anchor,
  CenteredContent,
  CenteringContainer,
  LargeLogoContainer,
  LargeNavContainer,
  NavigationItem,
  NavigationItems,
  LogInDiv,
} from 'components/Header/Styled'
import { CityDropdown, NavDropdown } from './NavDropdown'

// TODO: Breakup file
function NavLinks(siteNavLinks) {
  return (
    siteNavLinks &&
    siteNavLinks.length > 0 &&
    siteNavLinks.map((item, index) => {
      if (
        item.navigation_type === 'navigation_group' &&
        item.navigation_items &&
        item.navigation_items.length > 0
      ) {
        return (
          <NavigationItem key={`large_header_navdropdown${item.title}`}>
            <Anchor href={item.link}>
              <NavDropdown title={item.title} navigation_items={item.navigation_items} />
            </Anchor>
          </NavigationItem>
        )
      } else {
        return (
          <NavigationItem key={`large_header_navlink${item.link}${index}`}>
            <Anchor href={item.link}>
              <CenteringContainer>
                <CenteredContent>{item.title}</CenteredContent>
              </CenteringContainer>
            </Anchor>
          </NavigationItem>
        )
      }
    })
  )
}

const NavigationItemsRight = ({ rightNavigationItems, startedCta }) => {
  return (
    <NavigationItems isRight>
      <NavigationItem>
        <CenteringContainer>
          {rightNavigationItems && <CityDropdown cities={rightNavigationItems} />}
        </CenteringContainer>
      </NavigationItem>
      <NavigationItem>
        <Anchor href='/log-in'>
          <CenteringContainer>
            <LogInDiv>Log In</LogInDiv>
          </CenteringContainer>
        </Anchor>
      </NavigationItem>
      <CenteringContainer pr='20px'>
        <CenteredContent>
          <PrimaryButton href={startedCta.link} rel='nofollow'>
            {startedCta.text}
          </PrimaryButton>
        </CenteredContent>
      </CenteringContainer>
    </NavigationItems>
  )
}

export const LoggedOutLargeHeader = ({
  altTag,
  logo,
  siteNavigationItems,
  rightNavigationItems,
  startedCta,
}) => (
  <LargeNavContainer>
    <FlexDiv maxWidth='1170px' width='100%' alignItems='center'>
      <LargeLogoContainer>
        <a href='/'>
          <GenericLazyLoadImage alt={altTag} src={logo} height='60px' mt='11px' />
        </a>
      </LargeLogoContainer>
      <NavigationItems>{NavLinks(siteNavigationItems)}</NavigationItems>
      <NavigationItemsRight rightNavigationItems={rightNavigationItems} startedCta={startedCta} />
    </FlexDiv>
  </LargeNavContainer>
)
